import React from "react";
import { useNavigate, useSearchParams } from "react-router";
import { useLogout } from "./hooks/useLogout";
import "./index.css";
import { Button } from "./components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./components/ui/dialog";
import { useT } from "./i18n";

export function LogoutDialog() {
  const { logout } = useLogout();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const show = searchParams.has("logout");
  // Shown over S and Settings alike, in the language the user picked in S.
  const { t, language, dir } = useT();

  const hideDialog = React.useCallback(() => {
    setSearchParams((curr) => {
      curr.delete("logout");
      return curr;
    });
  }, [setSearchParams]);

  const onConfirm = React.useCallback(() => {
    setSearchParams((curr) => {
      curr.delete("logout");
      return curr;
    });
    logout();

    navigate("/", { replace: true });
  }, [setSearchParams, navigate, logout]);

  return (
    <Dialog open={show} onOpenChange={(open) => !open && hideDialog()}>
      <DialogContent showCloseButton={false} dir={dir} lang={language}>
        <DialogHeader>
          <DialogTitle>{t("signOut.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="px-4 py-4">{t("signOut.confirm")}</DialogDescription>
        <DialogFooter>
          <Button variant="outline" onClick={hideDialog}>
            {t("common.cancel")}
          </Button>
          <Button onClick={onConfirm}>{t("signOut.title")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
